import { getSneakerLocale } from 'shared/utils/getSneakerLocale';
import { requestService } from 'shared/utils/services/requestService';

export async function updateRegionPreferences(country) {
  const locale = getSneakerLocale();
  return requestService({
    url: '/web-api/v1/region_preferences',
    method: 'post',
    data: JSON.stringify({
      region_preferences: {
        country,
        locale,
      },
    }),
    withCredentials: true,
  });
}
